export enum PersonalInfoMemberTitle {
    MR = '126',
    MRS='127',
    MS='128',
    OTHER="147",
    I_DONT_WANT_DISCLOSE="148"
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/personal-info-title.enums.ts